import { WIX_PRO_GALLERY } from '@wix/app-definition-ids';
import { SearchDocumentType } from '@wix/client-search-sdk';
import { IndexableApp, LayoutType } from '../types';

export const ProGalleryApp: IndexableApp = {
  documentType: SearchDocumentType.ProGallery,
  appDefId: WIX_PRO_GALLERY,
  translations: {
    tabLabel: 'searchResults.tabs.label.proGallery',
    tabLabelWithCount: 'searchResults.tabs.label.proGallery.withCount',
    tabAccessibilityLabel:
      'searchResults.tabs.label.search-category.accessibilityLabel',
  },
  layout: LayoutType.Grid,
};
